import * as React from 'react';
import { colors } from '../styles/colors';

interface IProps {
    style?: React.CSSProperties;
}

export const NotificationTimeText: React.SFC<IProps> = ({ children, style }) => <p style={{ ...timeTextStyle, ...style }}>{children}</p>;

const timeTextStyle: React.CSSProperties = { color: colors.MEDIUM_GRAY_TEXT, fontSize: 11, fontWeight: 600 };



// WEBPACK FOOTER //
// ./src/SharedComponents/NotificationTimeText.tsx